import { useParams } from 'react-router-dom';
import { resolveParam } from 'utils';

/**
 * Returns the current `:campaignId` route param.
 *
 * Depending on the `isRequired` option, asserts presence of the parameter and returns
 * `number | undefined` or `number`, respectively.
 */
export const useCampaignId = <Required extends boolean = false>({ isRequired }: { isRequired?: Required } = {}) =>
  resolveParam({
    key: 'campaignId',
    paramSets: [useParams()],
    isRequired,
    convert: Number,
  });
